import { Region, Stack } from 'contentstack';

import ContentStackLivePreview from '@contentstack/live-preview-utils';
import { IStackSdk } from '@contentstack/live-preview-utils/dist/src/utils/types';
import { error } from '@/utils/safetyLog';

const CONTENT_STACK_API_KEY = process.env.CONTENT_STACK_API_KEY || '';
const CONTENT_STACK_DELIVERY_TOKEN = process.env.CONTENT_STACK_DELIVERY_TOKEN || '';
const CONTENT_STACK_ENVIRONMENT = process.env.CONTENT_STACK_ENVIRONMENT || '';
const CONTENT_STACK_PREVIEW_TOKEN = process.env.CONTENT_STACK_PREVIEW_TOKEN || '';
const CONTENT_STACK_API_HOST = process.env.CONTENT_STACK_API_HOST || '';
const CONTENT_STACK_APP_HOST = process.env.CONTENT_STACK_APP_HOST || '';
const CONTENT_STACK_REGION = process.env.CONTENT_STACK_REGION || '';

const stackSdk = Stack({
  api_key: CONTENT_STACK_API_KEY,
  delivery_token: CONTENT_STACK_DELIVERY_TOKEN,
  environment: CONTENT_STACK_ENVIRONMENT,
  region: (CONTENT_STACK_REGION as Region) || 'us',

  live_preview: {
    enable: true,
    management_token: CONTENT_STACK_PREVIEW_TOKEN,
    host: CONTENT_STACK_API_HOST,
  },
}) as unknown as IStackSdk;

if (CONTENT_STACK_API_HOST) {
  stackSdk.setHost(CONTENT_STACK_API_HOST);
}
export const livePreview = ContentStackLivePreview.init({
  stackSdk,
  clientUrlParams: {
    host: CONTENT_STACK_APP_HOST,
  },
  ssr: false,
});

export const { onEntryChange } = ContentStackLivePreview;

const renderOption = {
  span: (node: any, next: (arg0: any) => any) => next(node.children),
};

interface Entry {
  contentTypeUid: string;
  referenceFieldPath?: string[];
  jsonRtePath?: string[];
}

interface EntryLivePreview extends Entry {
  entryUid: string;
}

const MyStackSdk = {
  async getEntry({ contentTypeUid, referenceFieldPath, jsonRtePath }: Entry) {
    try {
      const query = stackSdk.ContentType(contentTypeUid).Entry('blt46ea8fd3df82c32a');
      if (referenceFieldPath) query.includeReference(referenceFieldPath);
      const baseQuery = query.toJSON();
      return await baseQuery.fetch();
    } catch (err: any) {
      error('getEntry error: ', err);
      throw new Error('Failed to getEntry');
    }
  },

  async getEntryByLivePreview({ contentTypeUid, entryUid, referenceFieldPath }: EntryLivePreview) {
    try {
      const query = stackSdk.ContentType(contentTypeUid).Entry(entryUid);
      if (referenceFieldPath) query.includeReference(referenceFieldPath);
      const baseQuery = query.toJSON();
      return await baseQuery.fetch();
    } catch (err: any) {
      error('getEntryByLivePreview error: ', err);
      throw new Error('Failed to getEntryByLivePreview');
    }
  },
};

export { stackSdk };

export default MyStackSdk;
